// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconPinUnselected = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='pin-unselected'
			xmlns='http://www.w3.org/2000/svg'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path
				fill='#757575'
				fillRule='evenodd'
				d='M18 0C11.2 0 4.825 3.946 1.757 10.054c-3.33 6.624-1.863 15.164 3.886 22.798.183.27 11.29 16.851 11.29 16.851L18 51.3l1.07-1.597L30.325 32.9c5.784-7.682 7.25-16.221 3.92-22.846C31.178 3.946 24.802 0 18.002 0m0 29c6.075 0 11-4.925 11-11S24.075 7 18 7 7 11.925 7 18s4.925 11 11 11'
				clipRule='evenodd'
			/>
		</svg>
	)
}
